/** Block unsafe HTML in schedule e-communication email templates. */
export function validateEcommEmailHtml(html) {
  const s = String(html || "");
  if (!s.trim() || s === "<p><br></p>") {
    return { allowed: true };
  }

  const rules = [
    { test: /<script[\s>]/i, message: "Scripts are not allowed in email templates." },
    { test: /<style[\s>]/i, message: "Embedded styles are not allowed in email templates." },
    { test: /javascript\s*:|vbscript\s*:/i, message: "Script links are not allowed." },
    { test: /data\s*:[^"'\s>]+/i, message: "Embedded data (e.g. base64) is not allowed." },
    { test: /<img\b/i, message: "Images are not allowed in email templates." },
    { test: /<iframe\b|<object\b|<embed\b/i, message: "Embedded content is not allowed." },
    { test: /class="ql-code-block"/i, message: "Code blocks are not allowed in email templates." },
    { test: /\son[a-z]+\s*=/i, message: "Inline event handlers are not allowed." },
  ];

  for (const { test, message } of rules) {
    if (test.test(s)) {
      return { allowed: false, message };
    }
  }

  return { allowed: true };
}

/**
 * Clean Word / Office clipboard HTML so paste can succeed under validateEcommEmailHtml.
 * Strips styles, scripts, images, MSO markup; keeps basic text structure.
 */
export function sanitizeEcommEmailHtmlForPaste(html) {
  let s = String(html || "");
  if (!s.trim()) return "";

  // Word conditional / HTML comments
  s = s.replace(/<!--\[if[\s\S]*?<!\[endif\]-->/gi, "");
  s = s.replace(/<!--[\s\S]*?-->/g, "");

  // Head-level and Office chrome
  s = s.replace(/<style[\s\S]*?<\/style>/gi, "");
  s = s.replace(/<script[\s\S]*?<\/script>/gi, "");
  s = s.replace(/<noscript[\s\S]*?<\/noscript>/gi, "");
  s = s.replace(/<\/?(?:html|head|body|meta|link|title|xml)(?:\s[^>]*)?>/gi, "");

  // Images / embeds (email templates disallow these)
  s = s.replace(
    /<(?:img|iframe|object|embed|picture|video|audio|svg)\b[^>]*(?:\/>|>[\s\S]*?<\/(?:img|iframe|object|embed|picture|video|audio|svg)>)/gi,
    "",
  );

  // Office namespace tags (o:p, w:*, v:*)
  s = s.replace(/<\/?(?:o|w|v|m):[^>]*>/gi, "");

  // Event handlers and dangerous URLs
  s = s.replace(/\s+on[a-z]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "");
  s = s.replace(
    /\s+(?:href|src)\s*=\s*(["'])\s*(?:javascript|vbscript|data)\s*:[^"']*\1/gi,
    "",
  );
  s = s.replace(/data:[^"'\s>]+/gi, "");

  // MSO / Word presentational attributes (keep tags, drop attributes)
  s = s.replace(/\s+class\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "");
  s = s.replace(/\s+style\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "");
  s = s.replace(/\s+[a-z]+:[a-z0-9_-]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "");
  s = s.replace(/\s+lang\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "");
  s = s.replace(/\s+align\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "");

  // Empty paragraphs / leftover Word spans often collapse fine in Quill
  s = s.replace(/(?:&nbsp;|\u00a0)/g, " ");
  s = s.replace(/\s{2,}/g, " ");

  return s.trim();
}
